module.exports = __webpack_public_path__ + "img/svg/expand-down.1eafb78f8cd132a7571c049d1aaa4227.svg";